import { MapOverviewArea, MapOverviewPoint } from "./map.types"

interface OverviewSize {
  width: number
  height: number
}

interface OverviewCoverMetrics extends OverviewSize {
  offsetX: number
  offsetY: number
}

export function getOverviewCoverMetrics(container: OverviewSize, image: OverviewSize): OverviewCoverMetrics | null {
  if (!container.width || !container.height || !image.width || !image.height) return null

  const scale = Math.max(container.width / image.width, container.height / image.height)
  const width = image.width * scale
  const height = image.height * scale

  return {
    width,
    height,
    offsetX: (container.width - width) / 2,
    offsetY: (container.height - height) / 2
  }
}

export function projectOverviewPoint(point: MapOverviewPoint, metrics: OverviewCoverMetrics): MapOverviewPoint {
  return {
    x: point.x * metrics.width + metrics.offsetX,
    y: point.y * metrics.height + metrics.offsetY
  }
}

export function normalizeOverviewPoint(point: MapOverviewPoint, metrics: OverviewCoverMetrics): MapOverviewPoint {
  return {
    x: Math.min(1, Math.max(0, (point.x - metrics.offsetX) / metrics.width)),
    y: Math.min(1, Math.max(0, (point.y - metrics.offsetY) / metrics.height))
  }
}

export function projectPointInOverviewArea(point: MapOverviewPoint, area: MapOverviewArea): MapOverviewPoint {
  const { x, y } = point
  return {
    x:
      (1 - x) * (1 - y) * area.p1.x +
      x * (1 - y) * area.p2.x +
      x * y * area.p3.x +
      (1 - x) * y * area.p4.x,
    y:
      (1 - x) * (1 - y) * area.p1.y +
      x * (1 - y) * area.p2.y +
      x * y * area.p3.y +
      (1 - x) * y * area.p4.y
  }
}

export function getOverviewAreaCenter(area: MapOverviewArea): MapOverviewPoint {
  const points = [area.p1, area.p2, area.p3, area.p4]
  return {
    x: points.reduce((sum, point) => sum + point.x, 0) / points.length,
    y: points.reduce((sum, point) => sum + point.y, 0) / points.length
  }
}
